// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historySensorAiTable__AVzX0 {
  width: 100%;
}
.historySensorAiTable__AVzX0 thead {
  background-color: var(--tables-title-surface);
}
.historySensorAiTable__AVzX0 th {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  min-width: 130px;
  padding: 15px;
  border-top: 1px solid var(--tables-primary-row-stroke);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  position: sticky;
  top: 0;
}
.historySensorAiTable__AVzX0 th:first-child {
  padding-left: 25px;
}
@media (max-width: 1400px) {
  .historySensorAiTable__AVzX0 th {
    min-width: none;
  }
}
.historySensorAiTable__AVzX0 tr {
  cursor: pointer;
}
.historySensorAiTable__AVzX0 tr:hover {
  background-color: var(--tables-primary-row-surface-hover);
}
.historySensorAiTable__AVzX0 td {
  font-size: 14px;
  line-height: 17px;
  padding: 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.historySensorAiTable__AVzX0 td:first-child {
  padding-left: 25px;
}

.alignRightTd__qDflN {
  text-align: right;
}

.infoTitle__a3stD {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
}

.infoDate__nY8k8 {
  font-size: 12px;
  line-height: 16px;
  color: var(--tables-primary-row-text-additional);
  margin-top: 5px;
  margin-bottom: 0;
}

.infoText__CKcwR {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.infoText__CKcwR p {
  margin: 0;
}

.viewHistoryBtn__xweaS {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-text-secondary);
  text-transform: uppercase;
  text-decoration: none;
  text-align: right;
  cursor: pointer;
  margin-left: auto;
}

.emptyRowBlock__POr1p {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  margin-top: 10px;
  height: 206px;
  border-bottom: none;
}

.skeletonText__bZbHw {
  width: 100%;
  height: 24px;
  padding: 0 10px;
}

.buttonsContainer__a1SI5 {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  padding: 25px;
  position: sticky;
  bottom: 0;
  background-color: var(--tables-primary-row-surface-default);
}

.addIcon__wjFnk path {
  fill: var(--buttons-text-secondary);
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorDetails/components/HistoryTableSensorAi/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;AA2EE;EACE,6CAAA;AAzEJ;AA4EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sDAAA;EACA,yDAAA;EACA,gBAAA;EACA,MAAA;AA1EJ;AA4EI;EACE,kBAAA;AA1EN;AA6EI;EAlBF;IAmBI,eAAA;EA1EJ;AACF;AA6EE;EACE,eAAA;AA3EJ;AA4EI;EACE,yDAAA;AA1EN;AA8EE;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,yDAAA;AA5EJ;AA8EI;EACE,kBAAA;AA5EN;;AAiFA;EACE,iBAAA;AA9EF;;AAiFA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;AA9EF;;AAiFA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,eAAA;EACA,gBAAA;AA9EF;;AAiFA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AA9EF;AAiFI;EACE,SAAA;AA/EN;;AAoFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAjFF;;AAoFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAjFF;;AAoFA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAjFF;;AAoFA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,2DAAA;AAjFF;;AAqFE;EACE,mCAAA;AAlFJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.historySensorAiTable {\n  width: 100%;\n\n  thead {\n    background-color: var(--tables-title-surface);\n  }\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    color: var(--tables-title-text);\n    text-transform: uppercase;\n    text-align: left;\n    min-width: 130px;\n    padding: 15px;\n    border-top: 1px solid var(--tables-primary-row-stroke);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    position: sticky;\n    top: 0;\n\n    &:first-child {\n      padding-left: 25px;\n    }\n\n    @media (max-width: 1400px) {\n      min-width: none;\n    }\n  }\n\n  tr {\n    cursor: pointer;\n    &:hover {\n      background-color: var(--tables-primary-row-surface-hover);\n    }\n  }\n\n  td {\n    font-size: 14px;\n    line-height: 17px;\n    padding: 15px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n    &:first-child {\n      padding-left: 25px;\n    }\n  }\n}\n\n.alignRightTd {\n  text-align: right;\n}\n\n.infoTitle {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n}\n\n.infoDate {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--tables-primary-row-text-additional);\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n.infoText {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  :global {\n    p {\n      margin: 0;\n    }\n  }\n}\n\n.viewHistoryBtn {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-text-secondary);\n  text-transform: uppercase;\n  text-decoration: none;\n  text-align: right;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.emptyRowBlock {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  margin-top: 10px;\n  height: 206px;\n  border-bottom: none;\n}\n\n.skeletonText {\n  width: 100%;\n  height: 24px;\n  padding: 0 10px;\n}\n\n.buttonsContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: auto;\n  padding: 25px;\n  position: sticky;\n  bottom: 0;\n  background-color: var(--tables-primary-row-surface-default);\n}\n\n.addIcon {\n  path {\n    fill: var(--buttons-text-secondary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historySensorAiTable": `historySensorAiTable__AVzX0`,
	"alignRightTd": `alignRightTd__qDflN`,
	"infoTitle": `infoTitle__a3stD`,
	"infoDate": `infoDate__nY8k8`,
	"infoText": `infoText__CKcwR`,
	"viewHistoryBtn": `viewHistoryBtn__xweaS`,
	"emptyRowBlock": `emptyRowBlock__POr1p`,
	"skeletonText": `skeletonText__bZbHw`,
	"buttonsContainer": `buttonsContainer__a1SI5`,
	"addIcon": `addIcon__wjFnk`
};
module.exports = ___CSS_LOADER_EXPORT___;
